import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { matchPath } from 'react-router-dom';
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import Sidebar from '../components/layout/sidebar.component';
import ROUTE_PATH from '../config/routes.config';
import { LayoutProvider } from '../contexts/layout.context';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// App root layout
const RootLayout = ({ children, isLoggedIn, categoriesTab }) => {
  const validRoutes = useMemo(
    () => [
      ...Object.values(ROUTE_PATH),
      `${ROUTE_PATH.CONTENT_CATEGORIES}/:slug`,
    ],
    []
  );

  const isValidRoute = validRoutes.some(
    (route) =>
      !window.location.pathname?.includes('popup-view') &&
      matchPath(route, window.location.pathname)
  );

  const [open, setOpen] = useState(false);
  const [isCollapse, setIsCollapse] = useState(false);

  return (
    <LayoutProvider value={{ isCollapse }}>
      <StyledRoot>
        {isLoggedIn && isValidRoute && (
          <Sidebar
            openNav={open}
            onOpenNav={() => setOpen(true)}
            onCloseNav={() => setOpen(false)}
            categoriesTab={categoriesTab}
            isCollapse={isCollapse}
            setIsCollapse={setIsCollapse}
          />
        )}

        {isLoggedIn && isValidRoute ? (
          <Main>
            <Container maxWidth={false}>{children}</Container>
          </Main>
        ) : (
          <Container maxWidth={false} style={{ padding: 0 }}>
            {children}
          </Container>
        )}
      </StyledRoot>
    </LayoutProvider>
  );
};

RootLayout.propTypes = {
  children: PropTypes.any.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  categoriesTab: PropTypes.array.isRequired,
};

export default RootLayout;
